module.exports = __webpack_public_path__ + "assets/img/1410.jpg?200380e70f17cd28aa94dd59a7aaae2e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1410.jpg
// module id = 1078
// module chunks = 0